import type { JSX } from '@builder.io/qwik';
import { useSignal } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import GlobeIcon from '~/icons/globe';
import DropdownIcon from '~/icons/dropdown';
import { NavContext } from '~/contexts/NavContext';

export default component$((): JSX.Element => {
  const {
    payloadToSSR: {
      layout: { header },
    },
  } = useContext(AppDataContext);
  const active = useSignal(false);

  const { theme } = useContext(NavContext);

  if (!header.editionsLinks?.value.length) return <></>;

  return (
    <div class='relative h-full flex items-center'>
      <button
        aria-label='select language'
        class='flex items-center gap-1'
        onClick$={() => (active.value = !active.value)}
      >
        <GlobeIcon cssClasses='fill-white' />
        <DropdownIcon
          active={active.value}
          type='triangle'
          color={theme.LinkDropdownIconColor.value}
          activeColor={theme.LinkColorTypeHover.value}
        />
      </button>
      {active.value && (
        <div
          id='languagemenu'
          class='p-6 absolute right-0 top-full bg-white shadow-megamenu max-w-min flex flex-col gap-5'
        >
          {header.editionsLinks.value.map((edition) => (
            <a
              href={edition.link.url}
              key={edition.link.url}
              class='block whitespace-nowrap font-group-tiny !text-sm leading-[19px] hover:text-primary'
            >
              {edition.link.text}
            </a>
          ))}
        </div>
      )}
    </div>
  );
});
